import { render, staticRenderFns } from "./VaultPasswordCopier.vue?vue&type=template&id=12af71a7&"
import script from "./VaultPasswordCopier.vue?vue&type=script&lang=js&"
export * from "./VaultPasswordCopier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports